import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'antd';
import { loginAction } from '../../../state/actions/creators/auth.actioncreator';
import { setInstalledAction } from '../../../state/actions/creators/app.actioncreator';
import LoginFormComponent from '../components/LoginForm.component';

class LoginPage extends PureComponent {
  installPrompt = null;

  componentDidMount() {
    const { installed } = this.props;
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      if (installed || (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true) {
        this.installPrompt = e;
        return false;
      }
    });
  }

  onSubmit(values) {
    const { username, password, dominio } = values;
    const { login } = this.props;
    const response = login(username, password, dominio);
    const { success, mensaje } = response;

  }

  async installApp() {
    const { installAction } = this.props;
    if (!this.installPrompt) return false;
    this.installPrompt.prompt();
    const outcome = await this.installPrompt.userChoice;
    if (outcome.outcome === 'accepted') {
      console.log('App Installed');
      installAction();
    } else {
      console.log('App not installed');
    }
    this.installPrompt = null;
    return false;
  }


  render() {
    const { authStatus } = this.props;
    const { running } = authStatus || false;

    return (
      <Row>
        <Col xs={{ span: 22, offset: 1 }} sm={{ span: 12, offset: 5 }} lg={{ span: 6, offset: 8 }}>
          <LoginFormComponent loading={running} onSubmit={this.onSubmit.bind(this)} />
        </Col>
      </Row>
    );
  }
}

LoginPage.propTypes = {
  login: PropTypes.func.isRequired,
  authStatus: PropTypes.object,
};
LoginPage.defaultProps = {
  authStatus: null,
};

const mapStateToProps = ({ sagas: AUTH, app: { installed } }) => ({
  authStatus: (AUTH !== null) ? AUTH : null,
  installed,
});

const mapDispatchToProps = dispatch => ({
  login: (username, password, dominio) => dispatch(loginAction(username, password, dominio)),
  installAction: () => dispatch(setInstalledAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
